
export const imageCodes = {
    
    mission: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmission.jpg?alt=media&token=d241a150-3c98-477f-a4dc-8ac538e4d095"
    },
    vision: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fvission.jpg?alt=media&token=2139059f-df1c-48f8-937f-8752bb91eba4"
    },
    value: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fvalue.jpg?alt=media&token=780fe0d8-d39e-47bf-992a-3aea9680e5c3"
    },
    values: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fvalues.jpg?alt=media&token=856eb90e-b1a5-427f-9cc1-7cd8277d6922"
    },
    aboutImg: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FUntitled-1%20(1).png?alt=media&token=8e3fd36a-48f2-44f5-b7c7-becc20ff4e97"
    },
}

export const textCodes = {

    estab: {
        code: "${merchantId}_tmpl_text_1",
        text: "Established in August 2012"
    },

    aboutText1: {
        code: "${merchantId}_tmpl_text_2",
        text: "JV Cooperation between Korea and Myanmar 50% - 50% operated until 2020 before the COVID 19 Crises hit the garment industry."
    },

    aboutText2: {
        code: "${merchantId}_tmpl_text_3",
        text: "However, we started operating again from November 2021 with the investment of Myanmar Co-founder and become Citizen fully own private company."
    },
    
    missionText: {
        code: "${merchantId}_tmpl_text_5",
        text: "To become a leading and responsible textile industry, which understand the human requirements and acts to balance these requirements by producing world-class products, keeping in view the social, economical and environmental concerns of the nation."
    },

    visionText: {
        code: "${merchantId}_tmpl_text_6",
        text: "To Manufacture products comparable to international standards, to be customer-focused and globally competitive through better quality, latest technology and continuous innovation."
    },

    valuesText: {
        code: "${merchantId}_tmpl_text_7",
        text: "QUALITY : We deliver the agreed quality on timely manner. RELATIONS : Our Success is based on good relations with all our partners and colleagues. We keep focus on creating value for our Customers and for the Group as a whole. SOLUTION : Continuous innovation to provide solutions for our customers ."
    },

}

export const titleCodes = {

    synergyGarment: {
        code: "${merchantId}_tmpl_title_1",
        title: "Myanmar Synergy Garment"
    },
    
    missionTitle: {
        code: "${merchantId}_tmpl_title_3",
        title: "Our Mission"
    },

    visionTitle: {
        code: "${merchantId}_tmpl_title_4",
        title: "Our Vision"
    },

    valuesTitle: {
        code: "${merchantId}_tmpl_title_5",
        title: "Our Values"
    },

}